/** How a metric's result reads, wherever metrics show (proof, cases, previews). */

interface MetricValues {
  value?: string | number | null;
  before?: string | number | null;
  after?: string | number | null;
  unit?: string | null;
}

const present = (v: string | number | null | undefined): v is string | number => v !== null && v !== undefined && String(v).trim() !== '';

/** "40 %", "from 10 to 2 days", or both: "40 % (from 10 to 2 days)". Nothing recorded reads as words. */
export function metricResult({ value, before, after, unit }: MetricValues): string {
  const withUnit = (v: string | number) => (unit ? `${v} ${unit}` : String(v));
  const change =
    present(before) && present(after)
      ? `from ${before} to ${withUnit(after)}`
      : present(after)
        ? `to ${withUnit(after)}`
        : present(before)
          ? `from ${withUnit(before)}`
          : null;
  if (present(value)) return change ? `${withUnit(value)} (${change})` : withUnit(value);
  return change ?? 'No value recorded';
}

